<!-- <p>incident-analytics-container works!</p> -->
<div class="incident-analytics-container">
  <section>
    <mat-grid-list
      [cols]="screenSize == ScreenType.Mobile ? 1 : 2"
      rowHeight="120px"
      ><mat-grid-tile rowspan="3"
        ><div class="incident-analytics-counters">
          <mat-grid-list cols="3" rowHeight="120px">
            <mat-grid-tile colspan="3"
              ><div
                [ngClass]="{
                  'incident-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'incident-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }"
              >
                <div>
                  <h2>{{ "Unique incidents" | uppercase }}</h2>
                  <h4>Incidents in the current month</h4>
                </div>
                <div>
                  <strong
                    ><h1>{{ "1340" }}</h1></strong
                  >
                </div>
              </div></mat-grid-tile
            >
            <mat-grid-tile colspan="3"
              ><div
                [ngClass]="{
                  'incident-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'incident-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }"
              >
                <div>
                  <h2>{{ "critical incident time" | uppercase }}</h2>
                  <h4>Average open time</h4>
                </div>
                <div>
                  <strong
                    ><h1>{{ "1.2" }}<span>s</span></h1>
                  </strong>
                </div>
              </div></mat-grid-tile
            >
            <mat-grid-tile colspan="3"
              ><div
                [ngClass]="{
                  'incident-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'incident-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }"
              >
                <div>
                  <h2>{{ "New Incidents" | uppercase }}</h2>
                  <h4>Incidents and alerts</h4>
                </div>
                <div>
                  <strong
                    ><h1>{{ "1340" }}</h1></strong
                  >
                </div>
              </div></mat-grid-tile
            >
          </mat-grid-list>
        </div></mat-grid-tile
      ><mat-grid-tile rowspan="3">
        <div class="tile-div">
          <mat-card class="incident-charts-card"
            ><mat-card-header class="incident-counter-card-header"
              >WEEKLY INCIDENTS</mat-card-header
            >
            <mat-card-content class="incident-charts-card-content">
              <app-visitor-breakdown
                [chartHeight]="300"
              ></app-visitor-breakdown>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </section>
  <br />
  <mat-divider></mat-divider>
  <br />
  <section>
    <mat-grid-list cols="1" rowHeight="120px">
      <mat-grid-tile rowspan="3">
        <div class="tile-div">
          <mat-card class="incident-charts-card"
            ><mat-card-header class="incident-counter-card-header"
              >RISK PROFILE</mat-card-header
            >
            <mat-card-content class="incident-charts-card-content">
              <app-incident-risk-profile [chartHeight]="285">
              </app-incident-risk-profile>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </section>
  <br />
  <mat-divider></mat-divider>
  <br />
  <section>
    <mat-grid-list
      [cols]="screenSize == ScreenType.Mobile ? 1 : 2"
      rowHeight="120px"
      gutterSize="25px"
    >
      <mat-grid-tile rowspan="3">
        <div class="tile-div">
          <mat-card class="incident-system-card"
            ><mat-card-header class="incident-counter-card-header"
              >SYSTEM LOGS
            </mat-card-header>
            <mat-card-content class="incident-tickets-card-content">
              <app-system-logs></app-system-logs>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
      <mat-grid-tile rowspan="3">
        <div class="tile-div">
          <mat-card class="incident-system-card"
            ><mat-card-header class="incident-tickets-card-header"
              ><div>NEW TICKETS</div>
              <div>
                <button (click)="onAddTicket()" mat-icon-button>
                  <mat-icon>add_circle</mat-icon>
                </button>
                <button mat-icon-button>
                  <mat-icon>clear</mat-icon>
                </button>
              </div>
            </mat-card-header>
            <mat-card-content class="incident-tickets-card-content">
              <div class="card-content">
                <mat-card *ngFor="let item of incidentTickets">
                  <mat-card-header>
                    <div mat-card-avatar class="header-image"></div>
                    <div class="header-titile-substitle">
                      <h4>{{ item.ticketCreateBy }}</h4>

                      <span>{{
                        getFormatedDateTime(item.ticketCreateDate)
                      }}</span>
                    </div>
                  </mat-card-header>
                  <mat-card-content
                    ><div class="card-ticket-descriptions">
                      {{ item.ticketDescription }}
                    </div></mat-card-content
                  >
                </mat-card>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </section>
</div>
